jQuery(document).ready(function ($) {
  $('.js-menu-button-open, .js-menu-button-close').click(function (e) {
    e.preventDefault();

    $('.js-menu-wrapper').toggleClass('open');
  });
});